import { useVpsHostingSectionContent } from './useVpsHostingSectionContent';
import { parseVpsHostingDedicatedContent } from '../utils/vpsHostingContent';

export const useVpsHostingDedicatedContent = () =>
  useVpsHostingSectionContent(parseVpsHostingDedicatedContent);
